import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { classNames, liveAnnounce, Level } from 'uitk-react-utils';
import styles from './uitk-loading-bar.css';

var UitkLoadingBarTypesMap = [
    ['determinate', 'determinate'],
    ['indeterminate', 'indeterminate']
];
var UitkLoadingBarTypes = new Map(UitkLoadingBarTypesMap);

var getClassNameList = classNames.bind(styles);
var COMPLETION_DELAY_DEFAULT = 300;
var LoadingBar = /** @class */ (function (_super) {
    __extends(LoadingBar, _super);
    function LoadingBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            delayPeriod: false,
            determinateHasFinished: false
        };
        return _this;
    }
    LoadingBar.getDerivedStateFromProps = function (props, state) {
        if (props.percentLoaded < 100 && state.determinateHasFinished) {
            return { determinateHasFinished: false, delayPeriod: false };
        }
        return null;
    };
    LoadingBar.prototype.componentDidMount = function () {
        var announceStartPhrase = this.props.announceStartPhrase;
        if (announceStartPhrase)
            liveAnnounce(announceStartPhrase, Level.POLITE);
    };
    LoadingBar.prototype.componentDidUpdate = function () {
        var _this = this;
        var delayPeriod = this.state.delayPeriod;
        var percentLoaded = this.props.percentLoaded;
        if (!delayPeriod && percentLoaded && percentLoaded >= 100) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ delayPeriod: true });
            setTimeout(function () { return _this.setState({ determinateHasFinished: true }); }, COMPLETION_DELAY_DEFAULT);
        }
    };
    LoadingBar.prototype.render = function () {
        var _a = this.props, l10n = _a.l10n, type = _a.type, percentLoaded = _a.percentLoaded, indeterminateHasFinished = _a.indeterminateHasFinished, announceEndPhrase = _a.announceEndPhrase;
        var determinateHasFinished = this.state.determinateHasFinished;
        var isDeterminate = UitkLoadingBarTypes.get(type) === 'determinate';
        var a11yDeterminate = l10n.formatText('loadingBar.determinate.allyLabel', percentLoaded);
        var a11yIndeterminate = l10n.formatText('loadingBar.indeterminate.allyLabel');
        var baseClass = 'uitk-loading-bar';
        var wrapperClassNames = getClassNameList(baseClass, !isDeterminate && baseClass + "-indeterminate");
        var barStyle = percentLoaded ? { width: Math.min(100, Math.max(0, percentLoaded)) + "%" } : {};
        if (determinateHasFinished || indeterminateHasFinished) {
            if (announceEndPhrase)
                liveAnnounce(announceEndPhrase, Level.POLITE);
            return null;
        }
        return (React.createElement("div", { className: wrapperClassNames },
            React.createElement("div", { className: getClassNameList(baseClass + "-container") },
                React.createElement("span", { className: "is-visually-hidden" }, isDeterminate ? a11yDeterminate : a11yIndeterminate),
                React.createElement("div", { className: getClassNameList(baseClass + "-current"), style: barStyle }))));
    };
    LoadingBar.defaultProps = {
        type: 'determinate',
        percentLoaded: 0,
        indeterminateHasFinished: false
    };
    return LoadingBar;
}(React.Component));
var UitkLoadingBar = function (props) {
    var l10n = useLocalization();
    return React.createElement(LoadingBar, __assign({ l10n: l10n }, props));
};
UitkLoadingBar.displayName = 'UitkLoadingBar';

export { LoadingBar, UitkLoadingBar };
